var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHyperlink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6668 8.66697C6.9531 9.04972 7.31837 9.36642 7.73783 9.5956C8.1573 9.82477 8.62114 9.96105 9.0979 9.99519C9.57466 10.0293 10.0532 9.96055 10.501 9.79349C10.9489 9.62643 11.3555 9.36502 11.6935 9.02697L13.6935 7.02697C14.3007 6.3983 14.6366 5.55629 14.629 4.6823C14.6215 3.80831 14.2709 2.97227 13.6529 2.35424C13.0348 1.73621 12.1988 1.38565 11.3248 1.37806C10.4508 1.37046 9.60881 1.70644 8.98013 2.31364L7.83347 3.45364M9.33347 7.33364C9.04716 6.95088 8.68189 6.63418 8.26243 6.40501C7.84297 6.17584 7.37913 6.03956 6.90237 6.00541C6.4256 5.97127 5.94708 6.04006 5.49924 6.20711C5.0514 6.37417 4.64472 6.63559 4.3068 6.97364L2.3068 8.97364C1.69961 9.60231 1.36363 10.4443 1.37122 11.3183C1.37881 12.1923 1.72938 13.0283 2.3474 13.6464C2.96543 14.2644 3.80147 14.615 4.67546 14.6226C5.54945 14.6301 6.39146 14.2942 7.02013 13.687L8.16013 12.547",
    stroke: "white",
    strokeOpacity: 0.9,
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlink);
export default __webpack_public_path__ + "static/media/hyperlink.96e18889d4244fcfb687bc227908e992.svg";
export { ForwardRef as ReactComponent };